export default __webpack_public_path__ + "static/media/iHRP.ea1f0fbb.svg";